






























































import _ from "lodash";

import { Component, Vue } from "vue-property-decorator";
import { Inspector } from "@/models";
import { Action, Getter, Mutation } from "vuex-class";

@Component
export default class InspectorList extends Vue {
  @Getter("app/hasBlockingRequests") public hasBlockingRequests: boolean;
  @Getter("inspectors/list") public list: Inspector[];

  @Action("inspectors/getInspectors") getInspectors: () => Promise<void>;

  @Mutation("inspectors/setCurrent")
  public setCurrent: (inspectors: Inspector) => void;

  @Action("inspectors/deleteInspectors") deleteStoreInspectors: (
    inspectors: Inspector
  ) => Promise<void>;

  public mounted() {
    Promise.all([this.getInspectors()]).catch((err: any) =>
      this.$onecentral.displayError(err)
    );
  }

  public editInspectors(inspectors: Inspector): void {
    this.setCurrent(inspectors);
    this.$router.push({
      name: "edit-inspectors",
      params: { id: inspectors.id || "" }
    });
  }

  public deleteInspectors(inspectors: Inspector): void {
    this.$onecentral
      .confirmPrompt()
      .then(() => this.deleteStoreInspectors(inspectors))
      .then(() => Vue.toasted.success("Inspectors deleted"))
      .catch((err: any) => this.$onecentral.displayError(err));
  }
}
